<!--NavBar-->
<app-navbar></app-navbar>
<router-outlet class="w-100"></router-outlet>
<app-footer></app-footer>
<!-- Footer -->
